import { Component, OnInit, Inject } from '@angular/core';
import { DialogBase } from 't4core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';

@Component({
  selector: 'app-insurance-image-info-dialog',
    templateUrl: './insurance-image-info-dialog.html',
    styleUrls: ['./insurance-image-info-dialog.css']
})
export class InsuranceImageInfoDialogComponent extends DialogBase implements OnInit {

    public monthFromNow: string = moment().add(1, 'months').format('ll');

    constructor(
        public dialogRef: MatDialogRef<InsuranceImageInfoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        super("InsuranceImageInfoDialogComponent");
    }

    ngOnInit() {
        this.loading = true;
        this.loading = false;
  }

    public agree() {
        this.dialogRef.close(true);
    }

    public cancel() {
        this.dialogRef.close(false);
    }

}
